import { render, staticRenderFns } from "./StationUserList.vue?vue&type=template&id=005480f6&"
import script from "./StationUserList.vue?vue&type=script&lang=js&"
export * from "./StationUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports